import React from "react";

import GuaranteesDataTable from "./GuaranteesDataTable";
import { EnumWrapper } from "../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../utils/enums/enums";

const GuaranteesPage = () => {
  return (
    <div className="sub-content">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <GuaranteesDataTable />
      </EnumWrapper>
    </div>
  );
};

export default GuaranteesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/GuaranteesPage.js